import React from "react";
import MenuOption from "./MenuOption";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import Diversity1OutlinedIcon from "@mui/icons-material/Diversity1Outlined";
import EmojiTransportationOutlinedIcon from "@mui/icons-material/EmojiTransportationOutlined";
import CommuteOutlinedIcon from "@mui/icons-material/CommuteOutlined";
import SettingsSuggestOutlinedIcon from "@mui/icons-material/SettingsSuggestOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import BoxComponent from "./Box";
import TypographyComponent from "./Typography";
import { useNavigate, useLocation } from "react-router-dom";
import { useAdmin } from "../context/AdminContext";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission, logout } = useAdmin();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleDashboard = () => {
    navigate("/dashboard");
  };
  const handleRides = () => {
    navigate("/rides");
  };
  const handleDrivers = () => {
    navigate("/drivers");
  };
  const handleCustomers = () => {
    navigate("/customers");
  };
  const handleCategory = () => {
    navigate("/vehicle-categories");
  };
  const handleConfig = () => {
    navigate("/configurations");
  };
  const handleLocation = () => {
    navigate("/locations");
  };
  const handleAdmin = () => {
    navigate("/admin");
  };
  const handleVehicleCategoryFares = () => {
    navigate("/vehicle-category-fares");
  };
  const handlePromoCodes = () => {
    navigate("/promo-codes");
  };

  // Check the current path
  const isActive = (path) => location.pathname === path;

  return (
    <BoxComponent
      width="15%"
      height="90vh"
      // padding='10px'
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      backgroundColor="var(--dark)"
    >
      <BoxComponent display="flex" flexDirection="column" gap="3px">
        {hasPermission("dashboard") && (
          <MenuOption
            onClick={handleDashboard}
            icon={DashboardOutlinedIcon}
            label="Dashboard"
            active={isActive("/dashboard")}
          />
        )}
        {hasPermission("rides") && (
          <MenuOption
            onClick={handleRides}
            icon={EmojiTransportationOutlinedIcon}
            label="Rides"
            active={isActive("/rides")}
          />
        )}
        {hasPermission("drivers") && (
          <MenuOption
            onClick={handleDrivers}
            icon={GroupOutlinedIcon}
            label="Drivers"
            active={isActive("/drivers")}
          />
        )}
        {hasPermission("customers") && (
          <MenuOption
            onClick={handleCustomers}
            icon={Diversity1OutlinedIcon}
            label="Customers"
            active={isActive("/customers")}
          />
        )}
        {hasPermission("vehicles") && (
          <MenuOption
            onClick={handleCategory}
            icon={CommuteOutlinedIcon}
            label="Vehicles"
            active={isActive("/vehicle-categories")}
          />
        )}
        {hasPermission("pricing") && (
          <MenuOption
            onClick={handleVehicleCategoryFares}
            icon={MonetizationOnOutlinedIcon}
            label="Pricing"
            active={isActive("/vehicle-category-fares")}
          />
        )}
        {hasPermission("promoCode") && (
          <MenuOption
            onClick={handlePromoCodes}
            icon={LocalOfferOutlinedIcon}
            label="Promo Codes"
            active={isActive("/promo-codes")}
          />
        )}
        {hasPermission("configurations") && (
          <MenuOption
            onClick={handleConfig}
            icon={SettingsSuggestOutlinedIcon}
            label="Configurations"
            active={isActive("/configurations")}
          />
        )}
        {hasPermission("locations") && (
          <MenuOption
            onClick={handleLocation}
            icon={PinDropOutlinedIcon}
            label="Locations"
            active={isActive("/locations")}
          />
        )}
        {hasPermission("admins") && (
          <MenuOption
            onClick={handleAdmin}
            icon={AdminPanelSettingsOutlinedIcon}
            label="Admin Roles"
            active={isActive("/admin")}
          />
        )}
      </BoxComponent>
      <BoxComponent
        display="flex"
        alignItems="center"
        justifyContent="left"
        height="6vh"
        padding="5px 10px"
        sx={{
          "&:hover": {
            cursor: "pointer",
            color: "var(--white)",
            backgroundColor: "var(--primary)",
          },
        }}
        onClick={handleLogout}
      >
        <LogoutIcon sx={{ color: "var(--white)" }} />
        <TypographyComponent marginLeft="15px" color="var(--white)">
          Logout
        </TypographyComponent>
      </BoxComponent>
    </BoxComponent>
  );
}
